import { render, staticRenderFns } from "./PaymentBreakdown.template.vue?vue&type=template&id=32933588&scoped=true&"
var script = {}
import style0 from "./PaymentBreakdown.template.vue?vue&type=style&index=0&id=32933588&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32933588",
  null
  
)

export default component.exports